import gql from 'graphql-tag';

export const BUY_PLAN = gql`
  mutation BuyCarePlan(
    $countryCode: String!
    $insuranceId: String!
    $phone: String!
    $agentCode: String
    $isTrial: Boolean
  ) {
    buyCarePlan(
      countryCode: $countryCode
      insuranceId: $insuranceId
      phoneNumber: $phone
      agentCode: $agentCode
      isTrial: $isTrial
    ) {
      id
    }
  }
`;

export const CARE_PAYSTACK_LINK = gql`
  mutation RequestCarePaystackLink(
    $plan: String!
    $isCardMethod: Boolean
  ) {
    CarePaystackLink(
      userPlanId: $plan
      isCardMethod: $isCardMethod
      partnerCode: ${process.env.NEXT_PUBLIC_PARTNER_CODE}
    ) {
      url
      pay_ref
    }
  }
`;

export const CARE_VERIFY_PAYSTACK = gql`
  mutation VerifyPaystackLink($reference: String) {
    CarePaystackConfirm(reference: $reference, partnerCode: ${process.env.NEXT_PUBLIC_PARTNER_CODE}) {
      id
      status
      paystackStatus
    }
  }
`;

export const ADD_USER_DEVICE = gql`
  mutation AddUserDevice(
    $imei: String!
    $purchaseProof: String
    $serial: String!
    $deviceModel: String
  ) {
    addUserDevice(
      imei: $imei
      pop: $purchaseProof
      serial_no: $serial
      device_id: $deviceModel
    ) {
      id
      userKycId
    }
  }
`;

export const USER_ADD_DEVICES = gql`
  mutation AddDevices($devices: [AddDevicePayload]) {
    userAddDevices(devices: $devices) {
      devices {
        id
      }
    }
  }
`;

export const CHECK_IMEI = gql`
  mutation CheckImei($imei: String!) {
    checkImei(imei: $imei) {
      imei
      model
      model_name
      status
    }
  }
`;

export const DECRYPT_IMEI = gql`
  mutation DecryptImei($imei: String!) {
    decryptData(encryptedData: $imei) {
      decryptedData
    }
  }
`;

export const VERIFY_USER = gql`
  mutation VerifyUser(
    $idNo: String!
    $idType: String!
    $dob: String!
    $firstName: String!
    $gender: String!
    $lastName: String!
  ) {
    verifyUser(
      identityNumber: $idNo
      identityType: $idType
      dob: $dob
      firstName: $firstName
      gender: $gender
      lastName: $lastName
    ) {
      result
      id
    }
  }
`;

export const ONBOARD_USER = gql`
  mutation OnboardUser($deviceId: String!, $kycId: String!, $plan: String!) {
    onboardUser(userDeviceId: $deviceId, userKycId: $kycId, userPlanId: $plan) {
      id
      kyckey
      status
    }
  }
`;

export const REQUEST_CLAIMS = gql`
  mutation requestClaims(
    $address: String!
    $comment: String
    $device_pass: String
    $estimate: Float!
    $latitude: Float
    $lg_total: Float
    $longitude: Float
    $model: String!
    $pickupDate: timestamptz!
    $sc_total: Float
    $services: [String!]!
    $userDevicePlanId: String!
    $vat: Float
    $window: String!
    $requestType: String
  ) {
    requestClaims(
      address: $address
      comment: $comment
      device_pass: $device_pass
      estimate: $estimate
      latitude: $latitude
      lg_total: $lg_total
      longitude: $longitude
      model: $model
      pickupDate: $pickupDate
      sc_total: $sc_total
      services: $services
      vat: $vat
      window: $window
      userDevicePlanId: $userDevicePlanId
      requestType: $requestType
    ) {
      requestId
      status
    }
  }
`;

export const ESTIMATE_CLAIMS = gql`
  mutation EstimateClaims($planId: ID!) {
    estimateClaims(planId: $planId) {
      cover_value
      covered_expenses
      expected_deductible
      remaining_coverage
      status
    }
  }
`;

export const PAYMENT_MONITOR = gql`
  mutation PaymentMonitor($id: String, $type: String) {
    paymentMonitor(id: $id, type: $type) {
      message
      status
    }
  }
`;

export const PAYSTACK_RENEWAL_LINK = gql`
  mutation PaystackRenewalLink($count: Int, $planId: String) {
    CarePlanRenewalPaystackLink(
      partnerCode: ${process.env.NEXT_PUBLIC_PARTNER_CODE}
      count: $count
      userPlanId: $planId
    ) {
      pay_ref
      url
    }
  }
`;

export const CONFIRM_RENEWAL = gql`
  mutation CarePlanRenewalPaystackConfirm($reference: String) {
    CarePlanRenewalPaystackConfirm(partnerCode: ${process.env.NEXT_PUBLIC_PARTNER_CODE}, reference: $reference) {
      amount
      id
      paystackStatus
      status
    }
  }
`;

export const VALIDATE_ONBOARDING_KEY = gql`
  mutation ValidateOnboardingKey($key: String!) {
    ValidateOnboardingKey(key: $key) {
      onboarding_key
      phone_number
      user_id
      insurance_plan_id
      user_plan_id
      partner_id
      user {
      id
      email
      phone
      }
      partner {
        id
        name
        code
      }
      insurance_plan {
      id
      name
      description
      planType
      price
      insurance_value
      }
      user_plan {
      id
      renewal_date
      }
    }
  }
`;

export const COMPLETE_ONBOARDING_KEY = gql`
  mutation CompleteOnboardingKey($key: String!, $user_plan_id: String!) {
    CompleteOnboardingKey(key: $key, user_plan_id: $user_plan_id) {
      onboarding_key
      phone_number
      user_id
      insurance_plan_id
      user_plan_id
      partner_id
      user {
      id
      email
      phone
      }
      partner {
        id
        name
        code
      }
      insurance_plan {
      id
      name
      description
      planType
      price
      insurance_value
      }
      user_plan {
      id
      renewal_date
      }
    }
  }
`;
